<!--
 * @Author: wujun
 * @Date: 2021-09-24 16:07:16
 * @LastEditTime: 2022-01-19 10:24:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \pc\src\views\medical-educate\admin\live_video\response_question\index.vue
-->
<template>
  <div class="total_color">
    <!-- 头部 -->
    <div>
      <van-nav-bar title="答题" left-text="" @click-left="onClickLeft" left-arrow>
        <!-- <template #right>
          <van-icon name="search" size="18" />
        </template> -->
      </van-nav-bar>
    </div>
   <div class="content">
     <div class="btnTitle" v-if="formData.examVOList.length==0">暂无题目</div>
       <Paper :option="option" :formData="formData" :timeLengh="timeLengh"></Paper>
       <div class="btn" v-if = "select == 1 && formData.examVOList.length>0">
            <!-- <el-button type="primary" @click="submit">提交</el-button> -->
            <van-button round type="info" @click="checkList" block>提交</van-button>
       </div>
   </div>
  <van-popup v-model="show" position="bottom" :style="{ height: 'auto' }">
    <!-- <div style="width:100%;height:100%;padding-bottom:30px">
      <div class="bottom_title">是否确认提交？提交后将无法修改答案。</div>
      <div class="bottom_btn">
        <van-button class="bottom_right" type="info" @click="submit">提交</van-button>
        <van-button type="default" @click="show = false">取消</van-button>
      </div>
    </div> -->
        <div class="delComent">
        <span>是否确认提交？提交后将无法修改答案。</span>
      </div>
      <div class="delComent" @click="submit" >
        <span class="reply">提交</span>
      </div>
      <div class="delComent" @click="show = false" >
        <span class="del">取消</span>
      </div>
    </van-popup>
  </div>
</template>
<script >
import Paper from '../../../components/business/medical-edu/paper/question.vue';

export default {

  components: {
    Paper
  },
  data () {
    return {
      formData: {
        dataId: 0,
        moduleId: 0,
        submitTotalCredit: 0,
        totalCredit: 0,
        examVOList: [
          {
            content: '',
            dataId: 0,
            id: 0,
            moduleId: 0,
            platformId: 0,
            questionCredit: 0,
            questionType: 2,
            submitAnswer: 0,
            submitQuestionCredit: 0,
            trueAnswer: '',
            examOptionsVO: [
              {
                content: '',
                id: 0,
                isTrue: true,
                sorted: ''
              }
            ]
          }
        ]
      },
      examSubmitList: '', // 存储要提交的值
      option: 1, // 1不带答案 2带答案
      select: 1, // 1展示按钮 2不展示
      dataId: 12,
      moduleId: 11,
      show: false, // 显示提示框
      timeLengh: 0,
      timeStatus: true,
      timer: null
    }
  },
  methods: {
    onClickLeft () {
      localStorage.removeItem('lastType');
      history.back()
    },
    checkList () {
      const examSubmitList = []
      const array = this.formData.examVOList
      array.map((item) => {
        examSubmitList.push({
          answers: item.submitAnswer,
          questionId: item.id
        })
      })
      let count = 0 // 用于记录是否有空值
      examSubmitList.map((item) => {
        if (item.answers.length === 0) {
          // this.$message.error('每道题都需要填写')
          count++
        }
        if (Array.isArray(item.answers[0])) {
          item.answers = item.answers[0]
        }
      })
      if (count > 0) {
        this.$message.error('每道题都需要填写')
        return false
      }
      this.show = true
      this.examSubmitList = examSubmitList
    },
    submit () {
      // @ts-ignore
      const platformId = this.$store.state.userInfo.platformId
      // @ts-ignore
      const Version = this.$version
      const examSubmitList = this.examSubmitList
      const Data = {
        dataId: this.dataId,
        moduleId: this.moduleId,
        //    platformId: platformId,
        examSubmitList: examSubmitList
      }
      // @ts-ignore
      this.$axios.post('edu/exam/submit', { data: Data, version: Version }).then((data) => {
        this.show = false
        this.answer()
      })
    },

    // 带答案列表
    answer () {
      // @ts-ignore
      const Version = this.$version
      const Data = {
        dataId: this.dataId,
        moduleId: this.moduleId
      }
      // @ts-ignore
      this.$axios.post('edu/exam/list/with/answer', { data: Data, version: Version }).then((res) => {
        this.formData = res.data
        this.option = 2
        this.select = 2
      })
    },

    // 判断是否已经提交过
    checkAnswer () {
      // @ts-ignore
      const Version = this.$version
      const Data = {
        dataId: this.dataId,
        moduleId: this.moduleId
      }
      // @ts-ignore
      this.$axios.post('/edu/exam/submit/check', { data: Data, version: Version }).then((res) => {
        if (res.data === true) {
          this.answer()
          // 清除延时器
          window.clearTimeout(this.timer);
        } else {
          this.info()
        }
      })
    },

    info () {
      const Version = this.$version
      const Data = {
        dataId: this.dataId,
        moduleId: this.moduleId
      }
      this.$axios.post('edu/exam/list/without/answer', { data: Data, version: Version }).then((res) => {
        this.formData = res.data
      })
    },
    // 获取时长
    getViewTime () {
      this.$axios.post('edu/study/history/get/view/time', {
        data: {
          dataId: this.$route.query.dataId,
          planCourseId: this.$route.query.id,
          moduleId: this.$route.query.moduleId
        // videoLength: parseInt(document.getElementById('video').duration)
        },
        version: this.$version
      }).then((res) => {
        if (res.status) {
          this.timeLengh = res.data ? res.data.viewTime : 0
        }
      })
    },
    // 每隔六十秒调用一次接口
    timeupdate () {
      if (!this.timeStatus) {
        return;
      }
      this.timeStatus = false
      this.timer = setInterval(() => {
        this.timeStatus = true;
        this.timeLengh = this.timeLengh + 1
        this.getTimeLength()
      }, 60000)
    },

    // 调用时长接口
    getTimeLength () {
      this.$axios.post('edu/study/history/statistic/time', {
        data: {
          dataId: this.$route.query.dataId,
          planCourseId: this.$route.query.id,
          moduleId: this.$route.query.moduleId
          //  videoLength
        },
        version: this.$version
      }).then(res => {
        if (res.data) {
          // console.log('sucess')
        }
      })
    }

  },


  mounted () {
    // this.moduleId = this.$route.query.moduleId
    // this.dataId = this.$route.query.dataId
    // this.checkAnswer()

    // 增加定时器传值
    if (this.$route.query && this.$route.query.id) {
      this.moduleId = this.$route.query.moduleId
      this.dataId = this.$route.query.dataId
      this.checkAnswer()
      this.getViewTime()
      this.timeupdate()
    } else {
      this.moduleId = this.$route.query.moduleId
      this.dataId = this.$route.query.dataId
      this.checkAnswer()
    }
  },
  // 销毁完成状态
  destroyed () {
    // 清除延时器
    window.clearTimeout(this.timer);
  }
}

</script>
  <style lang="scss" scoped>
  .total_color{
  width: 100vw;
  height: 100vh !important;
  background-color: rgb(245, 245, 245);
  // overflow: hidden;
  }
.content{
    width: 100%;
    position: relative;
    // background-color:#FFFFFF ;
  background-color: rgb(245, 245, 245);

    padding-bottom:100px;
}
.mar_top{
  width:100%;
  display:flex;
  justify-content:space-between;
  align-items:center
}
.mar_title{
  font-size:15px;
  color:#4884F0;
  cursor:pointer
}
.color{
    color:#409EFF;
}
.btn{
    display: flex;
    justify-content: center;
    width: 100%;
    position:absolute;
    bottom:10px;
    padding: 0 15px;
}
.btnTitle{
  display: flex;
  justify-content: center;
  position:absolute;
  top: 180px;
  width: 100%;
}
.bottom_title{
  text-align: center;
margin-top:20px;
font-size: 20px;
}
.bottom_btn{
  height: 100%;
  display: flex;
  justify-content:center;
  margin-top: 30px;
}
.bottom_right{
  margin-right: 20px;
}
.delComent {
  height: 50px;
  border-bottom: 1px $greyef1 solid;
  span {
    font-family: PingFangSC-Medium;
    font-size: 13px;
    color: $grey;
    text-align: center;
    line-height: 36px;
    display: block;
    text-align: center;
    padding-top: 7px;
  }
  .del {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: $red;
    text-align: center;
    line-height: 36px;
  }
  .reply {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: $grey;
    text-align: center;
    line-height: 36px;
  }
}
  </style>
